import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from '../../api/axios';
import { destroySession } from '../../helpers/Session';

const ReportYears = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');
    const selectedDepartment = sessionStorage.getItem('reportsDepartment');
    const selectedDepartmentSlug = sessionStorage.getItem('reportsDepartmentSlug');

    const { data: years, isLoading: isLoadingYears, error: errorYears } = useQuery({
        queryKey: ['payperiodyears'],
        queryFn: async () => {
            const res = await axios.get('payperiods/years', {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!accesstoken,
        retry: 1
    });

    useEffect(() => {
        if (errorYears) {
            if (errorYears.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [errorYears]);

    const handleSetReportsYear = (year) => {
        sessionStorage.setItem('reportsYear', year);
    };

    return (
        <div className='years'>
            <div className="page-header">
                <div className='title'>
                    <h1>Reports</h1>
                    <ul className='breadcrumbs'>
                        <li><NavLink to='/reports'>Reports</NavLink></li>
                        <li><span>{selectedDepartment}</span></li>
                    </ul>
                </div>
            </div>

            <div className='panels'>
                <div className='panel'>
                    <div className='content'>
                        <div className={`card ${isLoadingYears && 'loading'}`}>
                            {isLoadingYears ? (
                                [...Array(8)].map((__, i) => (
                                    <div className='card-content' key={i}>
                                        <a>
                                            <i className='fa fa-folder'></i>
                                            <span>Loading...</span>
                                        </a>
                                    </div>
                                ))
                            ) : (
                                years?.map(item => (
                                    <div className='card-content' key={item.id}>
                                        <NavLink to={`/reports/${selectedDepartmentSlug}/${item.year}`} title={item.year} aria-label={`Navigate to ${item.year} reports`} onClick={() => handleSetReportsYear(item.year)}>
                                            <i className='fa fa-folder'></i>
                                            <span>{item.year}</span>
                                        </NavLink>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportYears;